// src/lib/google-analytics.ts
// Google Analytics side of the analytics consent gate. gtag.js cannot be
// unloaded once injected, so withdrawal flips the documented `ga-disable-<id>`
// kill switch and drops the cookies it already set.

import { siteDetails } from "@/data/siteDetails";

const GA_ID = siteDetails.googleAnalyticsId;
const DISABLE_KEY = `ga-disable-${GA_ID}`;

function setDisabled(disabled: boolean): void {
  (window as unknown as Record<string, boolean>)[DISABLE_KEY] = disabled;
}

// _ga, _ga_<container>, _gid, _gat*. Cleared on the exact host and on the
// registrable domain, since gtag writes to the latter (".niftipay.com").
function clearGaCookies(): void {
  const host = window.location.hostname;
  const parts = host.split(".");
  const domains = [host, parts.length > 2 ? `.${parts.slice(-2).join(".")}` : `.${host}`];
  for (const entry of document.cookie.split("; ")) {
    const name = entry.split("=")[0];
    if (!/^_ga|^_gid$|^_gat/.test(name)) continue;
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; Path=/; Domain=${domain}`;
    }
    document.cookie = `${name}=; Max-Age=0; Path=/`;
  }
}

export function stopGoogleAnalytics(): void {
  if (typeof window === "undefined") return;
  setDisabled(true);
  clearGaCookies();
}

export function resumeGoogleAnalytics(): void {
  if (typeof window === "undefined") return;
  setDisabled(false);
}
